import { PaymentElement } from "@stripe/react-stripe-js";
import { useState, useEffect, useRef, } from "react";
import { useStripe, useElements , CardElement} from "@stripe/react-stripe-js";
import  { Redirect } from 'react-router-dom'
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate  } from 'react-router-dom';
import '../design/checkout.css';
import axios from 'axios';

export default function CheckoutFormNew( {tier , monthly, annual, founders} ) {
  const navigate = useNavigate();
  // Stripe elements
  const stripe = useStripe();
  const elements = useElements();
  // Form
  const[paymentType, setPaymentType] = useState("Monthly");
  const[question1, setQuestion1] = useState("");
  const[question2, setQuestion2] = useState("");
//   const[questionmessage, setQuestionmessage] = useState(false);
//   const[answermessage, setAnswermessage] = useState(false);
  const[question3, setQuestion3] = useState("");
  const[answer3, setAnswer3] = useState("");
  const[answer2, setAnswer2] = useState("");
  const[answer1, setAnswer1] = useState("");

//   const [message, setMessage] = useState(null);
//   const [email_message, setEmailMessage] = useState(null);
//   const [username_message, setUsernameMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [duplicate, setDuplicate] = useState(0);
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [passwordConfirm, setPasswordConfirm] = useState();
  const [name, setName] = useState();
  const [username,setUsername] = useState();
  const [mailchimp,setmailchimp] = useState(true);
  const [paymentsuccess,setPaymentsuccess] = useState(0);
  const [price, setPrice] = useState(monthly);
  var sha256 = require('js-sha256');

  const [passwordErrorMessage, setPasswordErorrMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const [platform, setPlatform] = useState("");


  const hasPageBeenRendered = useRef({effect1: false, effect2 :0});


  const handlequestion1 = (e) =>
    {
      setQuestion1(e.target.value);
    } 
  const handlequestion2 = (e) =>
    {
      setQuestion2(e.target.value);
    } 

  const handlequestion3 = (e) =>
    {
      setQuestion3(e.target.value);
    } 
  
  function checkString(str)
  {
    for (let i = 0; i < str.length; ++i) {
      let ch = str.charCodeAt(i);
      if (
          !(ch >= 97 && ch <= 122) && // a-z
          !(ch >= 48 && ch <= 57) // 0-9
      ) {
          return false
      }
      else{
        return true
      }
    }
  }
    


  const handlechange = (e) =>
  {
    setPaymentType(e.target.value);
    if (paymentType == 'Annual') {
      setPrice(monthly);
    }
    if (paymentType == 'Monthly'){
      setPrice(annual);
    }

  }




  useEffect(async ()=>{
    if (hasPageBeenRendered.current["effect2"]== 2){
      alert('creating account')
      .then(function (response) {
        /*axios.post("https://theclassplan.us18.list-manage.com/subscribe/post?u=adb7287e4f120953af0500b99&amp;id=51fe2f1df1&amp;f_id=00a56ce7f0",{"mce-EMAIL":email});*/
       console.log(response);
  
      })
      .catch((error) => {
        console.error(error);
        alert('Upload failed')
      })
;

      
    }
    else{
      hasPageBeenRendered.current["effect2"] = hasPageBeenRendered.current["effect2"] + 1; // test
    }
   
  
  },[paymentsuccess]);

  useEffect(async ()=>{
    if (hasPageBeenRendered.current["effect1"]){
    // fetch("http://localhost:8000/create-checkout-session", {
      fetch("https://payment-pqnu.onrender.com/create-checkout-session", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({price: price,
        email: email, 
        username:username, 
        name: name, 
        password: sha256(password),
        subscription_length: paymentType,
        subscription_method: "Stripe",
        tier:tier,
        founders:founders,
        SecurityQuestion1 : question1,
        SecurityQuestion1Answer : sha256(answer1),
        SecurityQuestion2 : question2,
        SecurityQuestion2Answer : sha256(answer2),
        mailchimpOptIn : mailchimp,
        platform : platform
      })
    })
      .then(res => {
        console.log("Status code" + res.status)
        if (res.ok) return res.json()
        console.log(res.body)
        return res.json().then(json => {Promise.reject(json)
      
      })
      })
      .then(({ url }) => {
        window.location = url
      })
      .catch(e => {
        console.error(e.error)
      })

      
    }
    hasPageBeenRendered.current["effect1"] = true;
  
  },[duplicate]);


  const validateSecurityQuestions = (question1, answer1, question2, answer2) => {
    if (!question1 || !question2) {
      setErrorMessage("Please choose 2 different security questions")
      return false;
    }

    if (question1 == question2) {
        setErrorMessage("Please choose 2 different security questions")
      return false;
    }

    if (!answer1 || !answer2) {
      setErrorMessage("Please make sure your security answers contain no special characters")
      return false;
    }

    // Manually lowercase the answers
    answer1 = answer1.toLowerCase();
    answer2 = answer2.toLowerCase();

    // Updated Regex: Only special characters are checked, uppercase is allowed
    const invalidAnswerPattern = /[!@#$%^&*(),.?":{}|<>]/;

    // Validate answers
    if (invalidAnswerPattern.test(answer1) || invalidAnswerPattern.test(answer2)) {
      setErrorMessage("Please make sure your answers contain no special characters")
      return false;
    }

    return true;
  }


  const validatePassword = (password, passwordConfirm) => {
    // form will handle empty submissions

    if (password.length < 8) {
      return "Password must be longer than 8 characters";
    }

    if (password != passwordConfirm) {
      return "Passwords must match";
    }

    return "";
}
  

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    // const valid_qus = (question1!=question2&& question2!=question3 && question1!=question3 && question1!="0" && question2!="0" && question3!="0" )
    // if (!valid_qus) {
    //   setQuestionmessage(true)
    //   return;
    // } else  {
    //   setQuestionmessage(false)
    //   if(!checkString(answer1)||!checkString(answer2)||!checkString(answer3)) {
    //     setAnswermessage(true);
    //     return;
    //   } else {
    //     setAnswermessage(false);
    //   }
    // }

    const isValidSecruityAnswers = validateSecurityQuestions(question1, answer1, question2, answer2)

    const isValidPassword = validatePassword(password, passwordConfirm)

    if (!isValidSecruityAnswers) {
      return;
    }

    if (isValidPassword != "") {
        setErrorMessage(isValidPassword)
      return;
    }

    if (platform == "" || platform == "Not Chosen") {
      setErrorMessage("Please chose your platform")
      return;
    }

    setIsProcessing(true);
    axios.post("https://springapi-xsvy.onrender.com/mobile/accountCreationCheck", {username: username, email: email})
    .then(function (response) {
      if (response.data.emailExist == true ){
        setErrorMessage("An account with this email already exists");
        setIsProcessing(false);
        return;
      };
      if (response.data.usernameExist == true ){
        setErrorMessage("This username is taken");
        setIsProcessing(false);
        return;
      };
      if (response.data.usernameExist == true ){
        setErrorMessage("This username is taken");
        setIsProcessing(false);
        return;
      };
      if (response.data.emailExist == false ){
        setErrorMessage(null);
      };
      if (response.data.usernameExist == false ){
        setErrorMessage(null);
      };
      if (response.data.emailExist == false && response.data.usernameExist == false)
      {
        setDuplicate(duplicate+1);
    

      }
      
    });
  }
  


  return (
    
    <form id="payment-form"  onSubmit={handleSubmit} >
      <label>
        Email
        <input 
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          name="EMAIL" 
          id="mce-EMAIL"
        />
        
      </label>
      <label>
        Username
        <input 
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        
      </label>
      <label>
        Password
        <input 
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </label>
      <label>
        Confirm Password
        <input 
          type="password"
          value={passwordConfirm}
          onChange={(e) => setPasswordConfirm(e.target.value)}
          required
        />
      </label>
      <label>
        Full Name
        <input 
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
          name="FNAME"
          id="mce-FNAME"
        />
      </label>

      <label>Security question 1
        <select value={question1} onChange={handlequestion1}>
        <option value="">Select</option>
        <option value="What was the name of your first pet?">What was the name of your first pet?</option>
        <option value="What is the name of the street you grew up on?">What is the name of the street you grew up on?</option>
        <option value="What is your oldest sibling's middle name?">What is your oldest sibling's middle name?</option>
        <option value="In what city/town did your parents meet?">In what city/town did your parents meet?</option>
        <option value="What was the make and model of your first car?">What was the make and model of your first car?</option>
        </select>
      </label>

      <input 
        value={answer1}
        onChange={(e) => setAnswer1(e.target.value)}
        required
      />
          

          <label>Security question 2
          <select value={question2} onChange={handlequestion2}>
            <option value="">Select</option>
            <option value="What was the name of your first pet?">What was the name of your first pet?</option>
            <option value="What is the name of the street you grew up on?">What is the name of the street you grew up on?</option>
            <option value="What is your oldest sibling's middle name?">What is your oldest sibling's middle name?</option>
            <option value="In what city/town did your parents meet?">In what city/town did your parents meet?</option>
            <option value="What was the make and model of your first car?">What was the make and model of your first car?</option>
          </select>
        </label>

        <input 
          value={answer2}
          onChange={(e) => setAnswer2(e.target.value)}
          required
        />

      <label>Payment type 
       <select value = {paymentType} onChange={handlechange}>
        <option value = "Monthly" > Monthly </option>
        <option value = "Annual"> Annual </option>
       </select>
       </label>

       <label>Platform 
       <select value = {platform} onChange={(e) => setPlatform(e.target.value)}>
       <option value = "not chosen" > Select </option>
        <option value = "apple" > iOS </option>
        <option value = "android"> Android </option>
       </select>
       </label>



{/* <div>
<label className="disclaimer-label">
The Class Plan App is currently available only on iOS devices. An Android version is coming soon!
  </label>
</div> */}

  <label className="checkbox-label">
  Subscribe to our mailing list  
          <input
            type="checkbox"
            checked={mailchimp}
            onChange={(event) => setmailchimp(event.target.checked)}
          />
        </label>

  {errorMessage && <div className="errorMessage">{errorMessage}</div>}

  {/* {errorMessage && <div className="errorMessage">{errorMessage}</div>} */}

      
    
      <button disabled={isProcessing || !stripe || !elements } id="submit">
        <span id="button-text">
          {isProcessing ? "Processing ... " : "Go to checkout"}
        </span>
      </button>

      <label className="returning-user-label"onClick={() => navigate("/existingUser/login")}>
            Returning User?
          </label>

      {/* <div>
<label className="country-disclaimer-label">
  * Currently unavailable in France. We are actively working to resolve this issue.
  </label>
</div> */}

    </form>

    
    
  );
}